/**
 * Transport for the Drive drag payload (item ids + source drive info)
 * between Editoor windows and the shell.
 *
 * The payload is stored under a private MIME type on purpose. A drag that
 * ends outside Editoor (Finder, another app) then carries nothing the host
 * understands. Storing it as text/plain made macOS Finder create a text
 * clipping file named after the JSON, and that clipping contained the
 * source drive's write token.
 */

export const DRIVE_DRAG_TYPE = 'application/x-editoor-drag';

export function writeDriveDragData(dataTransfer: DataTransfer, data: string): void {
    dataTransfer.setData(DRIVE_DRAG_TYPE, data);
}

export function readDriveDragData(dataTransfer: DataTransfer | null | undefined): string {
    return dataTransfer?.getData(DRIVE_DRAG_TYPE) || '';
}

/**
 * Serialise the drag payload into the DataTransfer. The source drive's write
 * token is dropped here on purpose: it travels only in memory and over the
 * BroadcastChannel (driveDragChannel), never in the DataTransfer.
 */
export function writeDriveDragPayload(
    dataTransfer: DataTransfer,
    payload: { items: string[]; sourceHasWriteAccess: boolean; sourceDriveId: string } & { sourceWriteToken?: unknown }
): void {
    const { sourceWriteToken: _omitted, ...safe } = payload;
    writeDriveDragData(dataTransfer, JSON.stringify(safe));
}
